import api from "../instance/axios_instance.ts";
import { UpdateUserInterface } from "../interface/updateUserInterface.ts";

    const UpdateUser = async (data: UpdateUserInterface): Promise<UpdateUserInterface> => {
    
    try {
        const response = await api.put<UpdateUserInterface>('/user_update', data);
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
    }
};

export default UpdateUser;